import React from "react";
import { Layout, Typography } from "antd";
import Footer from "./footer";
import { Link } from "react-router-dom";
const { Content, Header } = Layout;

export default function GuestLayout(appProps) {
  const { Title } = Typography;
  return (
    <Layout>
      <Header
        className="header"
        style={{
          position: "fixed",
          zIndex: 1,
          width: "100%",
          backgroundColor: "transparent",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "baseline",
            alignContent: "center",
            paddingTop: "5px",
          }}
        >
          <Link to="/">
            <img src="/hanyc_logo.png" width={"180px"} />
          </Link>
        </div>
        {/* <Title level={4}>BIG APPLE STARS AWARDS NOMINATION</Title> */}
        {/* <Col flex="100px">{logout}</Col> */}
      </Header>
      <Layout className="app">
        <Content
          className="site-layout-background"
          style={{
            // margin: "24px 16px",
            padding: 24,
            minHeight: "80vh",
          }}
        >
          {appProps.children}
        </Content>
      </Layout>
      <Footer />
    </Layout>
  );
}
